export const SET_TOKENS = 'SET_TOKENS'
export const SET_USER = 'SET_USER'
export const UPDATE_AUTHENTICATED = 'UPDATE_AUTHENTICATED'
export const UPDATE_VALIDATING = 'UPDATE_VALIDATING'
export const CLEAR_TOKENS = 'CLEAR_TOKENS'
export const CLEAR_USER = 'CLEAR_USER'
export const DESTROY_AUTH = 'DESTROY_AUTH'
export const CHANGE_DEFAULT_DEPARTMENT = 'CHANGE_DEFAULT_DEPARTMENT'
export const CHANGE_SHIPPING_RULES_STATUS = 'CHANGE_SHIPPING_RULES_STATUS'
export const SET_CURRENTLY_SELECTING_DEPARTMENT_ID =
	'SET_CURRENTLY_SELECTING_DEPARTMENT_ID'
export const SET_MFA_STATUS = 'SET_MFA_STATUS'
export const SET_MFA_CHALLENGE_CONTEXT = 'SET_MFA_CHALLENGE_CONTEXT'
